import { TestRun } from '../../types';

const failRateRenderer = (value: TestRun) => {
  const val = value.test_runs.fail_rate * 100;
  const formatted =
    Number(val.toFixed(2)) % 1 === 0 ? val.toFixed(0) : val.toFixed(2);

  return <>{formatted}%</>;
};

export default failRateRenderer;
